const SecondaryTitle = ({ title, className = '', animation = 'fade-left' }) => {
  return (
    <h2
      className={`font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold leading-snug drop-shadow-sm mb-6
        text-text-primary
        ${className}`}
      data-aos={animation}>
      {title}
    </h2>
  );
};

export default SecondaryTitle;
